import { useEffect, useState, useRef } from "react";
import axios from "axios";
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import robotoFont from '../../../fonts/Roboto-Regular-normal.js';


import MieszkaniecDaneWodaRozliczenieWydrukA4 from "../../Mieszkancy/Woda/Wydruk/MieszkaniecDaneWodaRozliczenieWydrukA4";



const WodaMieszkancySeryjneWydruki = props => {

    const { wybraneRozliczenie, zestaw, wybranaWspolnota } = props;

    const divRefs = useRef([]);
    const [dockList, setDockList] = useState([]);

    useEffect( () => setDockList([]), [zestaw ]);

    const [letGenerate, setLetGenerate] = useState(false);

    useEffect( () => setLetGenerate( zestaw?.length > 0 ? true : false ), [dockList]);
    // useEffect( () => setLetGenerate(tablicaObiektow?.length > 0 ? false : true), [tablicaObiektow]);
    // useEffect( () => setLetGenerate( divRefs?.current?.length > 0 ? true : false ), [divRefs.current]);

//   const addToList = async (id_user, id_wspolnoty, id_noty, nazwa_pliku, msc, grupa_numer) => {
//     try {
//       // Wysłanie PDF na backend
//       const response = await axios.post('/api/noty/dodaj', {id_user, id_wspolnoty, id_noty, nazwa_pliku, msc, grupa_numer});

//       if (response.data.success) {
//         dispatch(fetchNoty(wspolnota?.id));

//       } else {
//         alert('Wystąpił problem z wysyłaniem danych.');
//       }
//     } catch (error) {
//       console.error('Błąd podczas wysyłania danych.', error);
//     }
//   }

    const generatePDF = async () => {
        // setLoaderOn(true);
        const doc = new jsPDF('p', 'mm', 'a4');
        doc.addFileToVFS("Roboto-Regular.ttf", robotoFont);
        doc.addFont("Roboto-Regular.ttf", "Roboto-Regular", "normal");
        doc.setFont("Roboto-Regular");
    
        for (let i = 0; i < divRefs.current.length; i++) {
            const { ref } = divRefs.current[i];

            // Wymuszenie białego tła
            ref.style.backgroundColor = 'white';

            // Renderuj canvas
            const canvas = await html2canvas(ref, {
                scale: 2, // dobra jakość, można dać 1.5 jak chcesz mniejszy plik
                backgroundColor: '#ffffff',
                useCORS: true,
            });

            const imgData = canvas.toDataURL('image/jpeg', 0.8); // kompresja JPEG

            const pdfWidth = 210;
            const pdfHeight = 297;
            if (i > 0) doc.addPage();
            doc.addImage(imgData, 'JPEG', 0, 0, pdfWidth, pdfHeight);
        }

        const fileName = `${wybraneRozliczenie?.opis} - ${wybranaWspolnota?.name}.pdf`;
        doc.save(fileName);
    }


    const generateDocks = () => {
        return new Promise((resolve) =>{
            const wygenerowanyKodHTML = zestaw?.map((obj, index) => {

            return (
            <div           
                id={obj.id}
                ref={(el) => 
                    (divRefs.current[index] = {ref: el, refNr: obj.id})
                }
                key={index}
                className="container"
            >
                <MieszkaniecDaneWodaRozliczenieWydrukA4 
                    componentRef={null}   
                    rozliczenieWodyAkt={wybraneRozliczenie}
                    procent={obj.procent}
                    odczyty={obj.odczyty}
                    mieszkaniec={obj.mieszkaniec}
                    adres={obj.adres}
                />
            </div>
            )
            
        });
        setDockList(wygenerowanyKodHTML);
        resolve();
        })
    }

    return (
        <div>
            <div className="buttons">
                <button 
                    onClick={generateDocks} 
                    disabled={!letGenerate}
                >
                    1. Generuj podgląd
                </button>
                <button 
                    onClick={generatePDF}
                    disabled={!letGenerate}
                >
                    2. Zapisz pliki na dysku
                </button>
            </div>
            {dockList}
        </div>
    )
}

export default WodaMieszkancySeryjneWydruki;